module.exports = __webpack_public_path__ + "img/icon-map.a6fdd64c.svg";